import type { ReactNode } from "react";
import { PayoutsFrame, type PayoutsTab } from "./components/PayoutsFrame";

export interface PayoutsShowViewProps {
  /** Server-rendered Stripe AccountSession client secret for the first fetch. */
  initialClientSecret: string;
  /** Stripe publishable key for the embedded Connect components. */
  publishableKey: string;
  /** Mints a fresh AccountSession client secret when the initial one nears expiry. */
  fetchRefreshedClientSecret: () => Promise<string>;
  /** Localized, routed sub-nav tab definitions. */
  tabs: PayoutsTab[];
  /** Embedded Stripe Connect components rendered inside the overview tab. */
  children: ReactNode;
}

/**
 * Payouts overview surface: renders the shared `PayoutsFrame` sub-nav with the
 * "overview" tab active and the embedded Stripe components passed as children.
 * Purely presentational — all Inertia/route/session wiring lives in the container.
 */
export function PayoutsShowView({
  initialClientSecret,
  publishableKey,
  fetchRefreshedClientSecret,
  tabs,
  children,
}: PayoutsShowViewProps) {
  return (
    <PayoutsFrame
      currentTab="overview"
      fetchRefreshedClientSecret={fetchRefreshedClientSecret}
      initialClientSecret={initialClientSecret}
      publishableKey={publishableKey}
      tabs={tabs}
    >
      {children}
    </PayoutsFrame>
  );
}
